// ADA #1005 (WCAG 2.4.11 / 2.4.3): the mobile menu covers the page but never
// held the keyboard. Measured on the local stack at 390px with the panel open,
// walking Tab from the burger: 6 of 40 stops landed inside <main> (the carousel
// pause and the two slick arrows), and for every one of them the element a mouse
// would hit at its centre was the PANEL -- focus fully obscured, which is 2.4.11
// rather than merely off-screen. Escape did nothing: the panel stayed active and
// aria-expanded stayed true.
//
// inert, not a hand-rolled focus trap: one property takes a subtree out of the
// tab order, out of hit-testing and out of the accessibility tree at once, and
// it is the mechanism the checkout busy state already uses (directives.js,
// rsBusyBlock). A trap would duplicate it and drift.
//
// WHAT GETS INERTED: the panel lives INSIDE <header> (header.liquid:149, header
// spans :1-236), so inerting the header would take the burger with it. Instead
// walk from the header up to <body>, inerting the siblings at each level. That
// reaches <main>, the footer, the dialogs that precede the header and the
// body-level widgets, across all four layouts, without naming a single snippet
// -- so a template that adds a section later is covered without editing this.
// The header itself stays live, which is what the ticket asks for: the burger,
// logo, help and cart sit above the panel and remain operable.
const MOBILE_MENU_BREAKPOINT = '(min-width: 768px)';
let inertedByMobileMenu = [];

/**
 * Take everything outside the header out of reach while the menu covers it.
 * Only elements this function switched on are recorded, so releasing can never
 * clear an inert flag that something else (rsBusyBlock) is holding.
 */
function setPageBehindMenuInert(inert) {
    if (!inert) {
        inertedByMobileMenu.forEach((el) => { el.inert = false; });
        inertedByMobileMenu = [];

        return;
    }

    const header = $('header.header')[0];
    const body = $('body')[0];

    if (!header || !body) {
        return;
    }

    // Index loops, not forEach: the callback would close over the collector and
    // trip no-loop-func, which fails the gulp build and therefore the pipeline.
    for (let node = header; node && node !== body && node.parentElement; node = node.parentElement) {
        const siblings = node.parentElement.children;

        for (let i = 0; i < siblings.length; i += 1) {
            const sibling = siblings[i];

            // Skip one already inert for another reason -- rsBusyBlock holds
            // #layout on the checkout -- so releasing ours never clears theirs.
            if (sibling !== node && !sibling.inert) {
                sibling.inert = true;
                inertedByMobileMenu.push(sibling);
            }
        }
    }
}

/**
 * Open main menu that appears only for small screens
 */
function openMobileMenu() {
    $('.navbar-mobile-menu, .navbar-menu-toggle').addClass('active');
    $('.navbar-menu-toggle').attr('aria-expanded', 'true');
    $('body').addClass('no-scroll');
    setPageBehindMenuInert(true);
}

/**
 * Close main menu that appears only for small screens
 */
function closeMobileMenu() {
    $('.navbar-mobile-menu, .navbar-menu-toggle').removeClass('active');
    $('.navbar-menu-toggle').attr('aria-expanded', 'false');
    $('body').removeClass('no-scroll');
    setPageBehindMenuInert(false);
}

$(() => {
    $('.navbar-menu-toggle').on('click', function () {
        if ($(this).hasClass('active')) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });

    // ADA #1005: Escape closes the menu and hands the customer back to the
    // control they opened it with. Bound at document level because focus can sit
    // anywhere inside the panel -- including the search input, which is the first
    // stop -- and a handler on the panel would miss a keypress made while focus
    // is on the burger itself (the burger is a sibling of the panel, not inside).
    $(document).on('keydown', function (e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) {
            return;
        }

        const $toggle = $('.navbar-menu-toggle');

        if (!$toggle.hasClass('active')) {
            return;
        }

        closeMobileMenu();
        $toggle.trigger('focus');
    });

    // ADA #1005: a rotated phone must never be left with an inert page. The
    // panel is display:none above the breakpoint (navbar.scss), so without this
    // the menu would be invisible while still holding <main> and the footer out
    // of the tab order -- the whole page unreachable with nothing on screen to
    // explain it. Close on the way past 768px; that releases inert too.
    // addListener is the deprecated spelling kept as the fallback for Safari
    // before 14, which the rest of this theme still supports.
    if (window.matchMedia) {
        const desktop = window.matchMedia(MOBILE_MENU_BREAKPOINT);
        const onBreakpoint = (mql) => {
            if (mql.matches && $('.navbar-menu-toggle').hasClass('active')) {
                closeMobileMenu();
            }
        };

        if (desktop.addEventListener) {
            desktop.addEventListener('change', onBreakpoint);
        } else if (desktop.addListener) {
            desktop.addListener(onBreakpoint);
        }
    }

    $('.site-nav--has-dropdown > a').on('click touchend', function (e) {
        const navItem = $(this).closest('li');
        const showDropdownClass = 'show-dropdown';

        if (!navItem.hasClass(showDropdownClass)) {
            e.preventDefault();
            navItem.addClass(showDropdownClass);
            navItem.attr('aria-expanded', 'true');
        } else {
            e.preventDefault();
            navItem.removeClass(showDropdownClass);
            navItem.attr('aria-expanded', 'false');
        }
    });

    $('#toggleFilters').on('click', function () {
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', String(!expanded));
    });

    // ADA #893 / #893b (WCAG 2.1.2 / 4.1.2): make every header dropdown
    // keyboard-escapable. Each opens purely via CSS :focus-within on its
    // container (.navbar-item mega-menu; .navbar-menu-item help / customer
    // service / account / cart), which we keep. wireEscClose ADDS: Escape
    // closes the panel and returns focus to the opener (a transient
    // .nav-esc-collapsed class out-specifies :focus-within so it actually
    // hides — see navbar.scss), with focusout/mouseenter clearing the class so
    // hover for sighted mouse users is unchanged. aria-expanded is reflected
    // only when the opener already declares it, so a plain navigational link
    // (the cart icon) is not mislabeled as a disclosure.
    const NAV_COLLAPSED = 'nav-esc-collapsed';
    const navEscGroups = [];

    function wireEscClose($items, openerSel) {
        navEscGroups.push({ $items, openerSel });

        $items.on('keydown', function (e) {
            if (e.key !== 'Escape' && e.keyCode !== 27) {
                return;
            }
            const $opener = $(this).addClass(NAV_COLLAPSED).find(openerSel).first();
            if ($opener.is('[aria-expanded]')) {
                $opener.attr('aria-expanded', 'false');
            }
            $opener.trigger('focus');
        });

        $items.on('focusin', function () {
            if (!$(this).hasClass(NAV_COLLAPSED)) {
                const $opener = $(this).find(openerSel).first();
                if ($opener.is('[aria-expanded]')) {
                    $opener.attr('aria-expanded', 'true');
                }
            }
        });

        $items.on('focusout', function (e) {
            // Keep state while focus stays inside the item (into the panel, or
            // the Esc-driven return to the opener); reset once it truly leaves.
            if (e.relatedTarget && $.contains(this, e.relatedTarget)) {
                return;
            }
            const $opener = $(this).removeClass(NAV_COLLAPSED).find(openerSel).first();
            if ($opener.is('[aria-expanded]')) {
                $opener.attr('aria-expanded', 'false');
            }
        });

        $items.on('mouseenter', function () {
            $(this).removeClass(NAV_COLLAPSED);
        });
    }

    wireEscClose($('.navbar-item'), '.navbar-link');
    wireEscClose($('.navbar-menu-item'), '.navbar-menu-link');

    // ADA #980 (WCAG 1.4.13): the same panels also open on hover, and hover
    // never moves focus — so the keydown above, bound to the container, is
    // never reached: the event originates at <body> and bubbles away from the
    // header, not through it. Escape then did nothing and the panel kept
    // covering the page until the pointer moved off, which a visitor with a
    // tremor or limited dexterity cannot rely on doing.
    //
    // One document-level listener closes whichever panel the pointer is
    // currently over. :hover is read from the element rather than tracked in
    // JS so it cannot desync from the stylesheet that opens the panel. No
    // focus is moved: focus is on <body> in this case and belongs there.
    // Opening is untouched; mouseenter/focusout still clear the class, so the
    // next hover reopens normally.
    $(document).on('keydown', function (e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) {
            return;
        }
        navEscGroups.forEach(function (group) {
            group.$items.each(function () {
                if (!this.matches(':hover')) {
                    return;
                }
                const $opener = $(this).addClass(NAV_COLLAPSED).find(group.openerSel).first();
                if ($opener.is('[aria-expanded]')) {
                    $opener.attr('aria-expanded', 'false');
                }
            });
        });
    });
});
